const getRuntimeEnv = () => {
  if (typeof window === 'undefined') return {}
  return window.__ENV__ || {}
}

const getBuildEnv = () => {
  if (typeof process === 'undefined') return {}
  if (!process.env) return {}
  return process.env
}

export const getEnv = (key, fallback = undefined) => {
  const runtimeValue = getRuntimeEnv()[key]
  if (runtimeValue !== undefined && runtimeValue !== '') return runtimeValue

  const buildValue = getBuildEnv()[key]
  if (buildValue !== undefined && buildValue !== '') return buildValue

  return fallback
}
